export function formatCommentary(text: string): string {
  if (!text) return '';

  return text
    .replace(/\n\n|\r\n\r\n|\r\r/g, '<br><br>')
    .replace(/\r\n|\n|\r|\x0b/g, '<br>')
    .replace(/\r\?/g, '<br>-')
    .replace(/\?/g, '-');
}

